import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Raven from 'raven-js';
// import registerServiceWorker from './registerServiceWorker';

import AppProvider from './components/AppProvider';
import App from './components/App';
import App2 from './components/App2';
import Home from './components/Home/';
import Checkout from './components/Checkout/';
import Confirmation from './components/Checkout/Confirmation';
import MenuTwo from './components/MenuTwo';
import NotFound from './components/NotFound';
import {
  SecurityPolicyPage,
  RefundsPolicyPage,
  DeliveryPolicyPage,
  TermsPage,
  PrivacyPolicyPage,
  CookiesPolicyPage,
} from './components/Legal';
import { isRestaurantOpen } from './helpers';

import theme from './components/styled/theme';
import './components/styled/GlobalStyle';

if (process.env.NODE_ENV !== 'development') {
  Raven.config('https://66c5381e88814b0a9a3ed7de302813eb@sentry.io/1244190').install();
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isRestaurantOpen ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

ReactDOM.render(
  <AppProvider>
    <ThemeProvider theme={theme}>
      <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/legal/security" component={SecurityPolicyPage} />
            <Route exact path="/legal/refunds" component={RefundsPolicyPage} />
            <Route exact path="/legal/delivery" component={DeliveryPolicyPage} />
            <Route exact path="/legal/terms" component={TermsPage} />
            <Route exact path="/legal/privacy" component={PrivacyPolicyPage} />
            <Route exact path="/legal/cookies" component={CookiesPolicyPage} />
            <PrivateRoute exact path="/ordenar" component={App} />
            <PrivateRoute exact path="/ordenar/checkout" component={Checkout} />
            <PrivateRoute exact path="/ordenar/confirmacion" component={Confirmation} />
            <PrivateRoute exact path="/ordenar-menu2" component={App2} />
            {/* <PrivateRoute exact path="/resumen" component={OrderSummaryPage} /> */}
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    </ThemeProvider>
  </AppProvider>,
  document.getElementById('root')
);
// registerServiceWorker();
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
